import { render, staticRenderFns } from "./PartnerVerticalNavMenuItem.vue?vue&type=template&id=46681dd7"
import script from "./PartnerVerticalNavMenuItem.vue?vue&type=script&lang=js"
export * from "./PartnerVerticalNavMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports